// ReportDocxDataModal.tsx
import React from "react";
import { Code, Modal, ScrollArea, Stack } from "@mantine/core";
import { useAppSelector } from "../../../hooks";
import { selectCurrentReportDocxData } from "./reportSelectors";

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const ReportDocxDataModal: React.FC<Props> = ({ opened, onClose }) => {
  const docxData = useAppSelector(selectCurrentReportDocxData);
  return (
    <Modal opened={opened} onClose={onClose} title="Docx-data (debug)" size="xl">
      <Stack gap="xs">
        <ScrollArea h={520} type="auto">
          <Code block>{JSON.stringify(docxData, null, 2)}</Code>
        </ScrollArea>
      </Stack>
    </Modal>
  );
};
